import { fetchApi } from 'marketing-website/utils/fetch';
import { API_CREATE_ACCOUNT } from 'marketing-website/constants/api';
import {
  MARVELAPP_PROJECTS,
  MARVELAPP_ONBOARDING,
} from 'marketing-website/constants/urls';
import querystring from 'querystring';

export function isEmailValid(value) {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (value) {
    return emailRegex.test(value.trim());
  }
  return false;
}

export function isPasswordValid(value) {
  if (value) {
    return value.trim().length >= 8;
  }
  return false;
}

export function isCompanyNameValid(value) {
  if (value) {
    return value.trim().length > 1;
  }
  return true;
}

export function getUsernameFromEmail(email) {
  const username = /(.*)@.*/.exec(email);
  if (username && username.length > 1) {
    return username[1];
  }
  // fallback to email if regex didn't get anything
  return email;
}

export function validateEmailAndPassword(email, password, errors) {
  if (!isEmailValid(email)) {
    errors.push('email');
  }

  if (!isPasswordValid(password)) {
    errors.push('password');
  }
}

export function generateBackendErrorMessage({
  e,
  genericErrorMsg,
  emailErrorMsg,
  inviteTokenErrorMsg,
}) {
  // Take the first key in the error data object and use it to map
  // to the correct error message object
  const errorType = e.data && Object.keys(e.data)[0];

  switch (errorType) {
    case 'email':
      return emailErrorMsg;
    case 'invite_token':
      return inviteTokenErrorMsg;
    default:
      return genericErrorMsg;
  }
}

export function makeCreateAccountRequest({
  email,
  password,
  name,
  occupation,
  success,
  failure,
}) {
  fetchApi('POST', API_CREATE_ACCOUNT, {
    email,
    password,
    occupation,
    name: name || getUsernameFromEmail(email),
  })
    .then(success)
    .catch(failure);
}

function getQueryParams(qs) {
  return querystring.parse(qs.slice(1));
}

export function getUrlWithRedirect(url) {
  const next = getNextRedirectParam();
  return `${url}?${querystring.stringify({ next })}`;
}

export function getSignupUrlWithRedirect() {
  const next = getNextRedirectParam(MARVELAPP_ONBOARDING);
  return `/signup?${querystring.stringify({ next })}`;
}

function getSearchString() {
  let searchString = `''`;
  if (typeof window !== 'undefined') {
    searchString = window.location.search;
  }
  return searchString;
}

export function getNextRedirectParam(defaultRedirect = MARVELAPP_PROJECTS) {
  const searchString = getSearchString();
  const params = getQueryParams(searchString);
  const redirectString = params.next || defaultRedirect;

  // we need to ensure we're not allowing open redirects so our users don't get phished
  // https://www.owasp.org/index.php/Unvalidated_Redirects_and_Forwards_Cheat_Sheet
  // make sure all our redirects are relative
  if (
    !redirectString ||
    redirectString.charAt(0) !== '/' ||
    redirectString === 'undefined'
  ) {
    return defaultRedirect;
  }

  // make sure no protocol-relative urls slip through by removing
  // all but the first slash from the start of the url
  return redirectString.replace(/\/+/, '/');
}

// When signing up, set the default redirect to /onboarding
export function getNextSignupRedirect() {
  return getNextRedirectParam(MARVELAPP_ONBOARDING);
}

export function getIgnoreMarketingParam() {
  const searchString = getSearchString();
  const params = getQueryParams(searchString);
  return params.out === 'true' || false;
}

export function getCommenterParam() {
  const searchString = getSearchString();
  const params = getQueryParams(searchString);
  return params.commenter === 'true' || false;
}

export function getCnameForUrl() {
  if (typeof window === 'undefined') {
    return null;
  }

  const host = window.location.host;

  if (host === 'localhost') {
    return null;
  }

  const cname = host.split('.')[0];

  if (cname === 'marvelapp') {
    return null;
  }

  return cname;
}

export function splitNames(name) {
  const fullName = name.split(' ');
  const firstName = fullName[0];
  let lastName = fullName[fullName.length - 1];
  if (firstName === lastName) {
    lastName = '';
  }
  const names = {
    firstName,
    lastName,
  };
  return names;
}



// WEBPACK FOOTER //
// ./src/utils/forms.js